<app-nav titulo="Nuevo Contrato" descripcion="Complete los datos del contrato de locación.">
    <div class="new-contract">

        <mat-horizontal-stepper linear #stepper class="form-stepper">

            <!-- STEP 1: Selección de Garantía -->
            <mat-step [completed]="!!warranty">
                <ng-template matStepLabel>Selección de Garantía</ng-template>

                <div class="form-step actions-step">
                    <button mat-raised-button color="primary" type="button" (click)="openModal()">
                        Seleccionar Garantía
                    </button>

                    <div class="selected-warranty" *ngIf="warranty">
                        <div class="warranty-info">
                            <h4>Garantía Seleccionada</h4>
                            <p><b>Propiedad:</b> {{ warranty.propiedad.direccion.calle }} {{
                                warranty.propiedad.direccion.numero }}
                                <span *ngIf="warranty.propiedad.direccion.piso">Piso {{
                                    warranty.propiedad.direccion.piso }}</span>
                                <span *ngIf="warranty.propiedad.direccion.departamento">Dpto {{
                                    warranty.propiedad.direccion.departamento }}</span>
                            </p>
                            <p><b>Inquilino:</b> {{ getNombreInquilino(warranty) }}</p>
                            <p><b>Agente:</b> {{ warranty.agente.nombre }} {{ warranty.agente.apellido }}</p>
                            <p><b>Alquiler:</b> ${{ warranty.cotizacion.alquiler | number }}</p>
                        </div>

                        <!-- Sección CUIT integrada -->
                        <div class="cuit-section">
                            <h4>Completar CUIT</h4>

                            <div class="row">
                                <!-- Propietarios -->
                                <div class="col-md-6">
                                    <h5>Propietarios</h5>
                                    <div *ngFor="let prop of contratoDTO.propietarios; let i = index"
                                        class="person-row">
                                        <div class="person-info">{{ prop.nombre }}</div>
                                        <mat-form-field appearance="outline" class="cuit-field">
                                            <mat-label>CUIT</mat-label>
                                            <input matInput [(ngModel)]="prop.cuit" placeholder="XX-XXXXXXXX-X">
                                        </mat-form-field>
                                    </div>
                                </div>

                                <!-- Inquilinos -->
                                <div class="col-md-6">
                                    <h5>Inquilinos</h5>
                                    <div *ngFor="let inq of contratoDTO.inquilinos; let i = index" class="person-row">
                                        <div class="person-info">{{ inq.nombre }}</div>
                                        <mat-form-field appearance="outline" class="cuit-field">
                                            <mat-label>CUIT</mat-label>
                                            <input matInput [(ngModel)]="inq.cuit" placeholder="XX-XXXXXXXX-X">
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="form-step-buttons">
                            <button mat-raised-button color="accent" type="button" matStepperNext>
                                Continuar
                            </button>
                        </div>
                    </div>
                </div>
            </mat-step>

            <!-- STEP 2: Datos del Contrato -->
            <mat-step [completed]="contratoDTO.fechaFirma && contratoDTO.ciudadFirma">
                <ng-template matStepLabel>Datos del Contrato</ng-template>

                <div class="form-step">
                    <!-- Layout con CSS Grid -->
                    <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 16px;">
                        <!-- Fecha de Firma -->
                        <mat-form-field appearance="outline">
                            <mat-label>Fecha de Firma *</mat-label>
                            <input matInput [matDatepicker]="pickerFirma" [(ngModel)]="contratoDTO.fechaFirma"
                                (dateChange)="onFechaFirmaChange($event)">
                            <mat-datepicker-toggle matSuffix [for]="pickerFirma"></mat-datepicker-toggle>
                            <mat-datepicker #pickerFirma></mat-datepicker>
                        </mat-form-field>

                        <!-- Ciudad de Firma -->

                        <mat-form-field appearance="outline">
                            <mat-label>Ciudad de Firma *</mat-label>
                            <input matInput [(ngModel)]="contratoDTO.ciudadFirma"
                                placeholder="Ej: Ciudad Autónoma de Buenos Aires">
                        </mat-form-field>

                        <!-- Fecha de Inicio -->
                        <mat-form-field appearance="outline">
                            <mat-label>Fecha de Inicio *</mat-label>
                            <input matInput [matDatepicker]="pickerInicio" [(ngModel)]="contratoDTO.fechaInicioAlquiler"
                                (dateChange)="onFechaInicioChange($event)">
                            <mat-datepicker-toggle matSuffix [for]="pickerInicio"></mat-datepicker-toggle>
                            <mat-datepicker #pickerInicio></mat-datepicker>
                        </mat-form-field>


                        <!-- Fecha Fin -->
                        <mat-form-field appearance="outline">
                            <mat-label>Fecha de Fin *</mat-label>
                            <input matInput [matDatepicker]="pickerFin" [(ngModel)]="contratoDTO.fechaFinAlquiler"
                                (dateChange)="onFechaFinChange($event)">
                            <mat-datepicker-toggle matSuffix [for]="pickerFin"></mat-datepicker-toggle>
                            <mat-datepicker #pickerFin></mat-datepicker>
                        </mat-form-field>


                        <!-- Plazo (calculado automáticamente) -->
                        <mat-form-field appearance="outline">
                            <mat-label>Plazo (meses) *</mat-label>
                            <input matInput type="number" [(ngModel)]="contratoDTO.plazoContrato" readonly>                            
                        </mat-form-field>


                        <!-- Tipo de Inmueble -->
                        <mat-form-field appearance="outline">
                            <mat-label>Tipo de Inmueble *</mat-label>
                            <mat-select [(ngModel)]="contratoDTO.tipoInmueble">
                                <mat-option *ngFor="let tipo of tiposInmueble" [value]="tipo.value">
                                    {{ tipo.label }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>

                        <!-- Moneda de Pago -->
                        <mat-form-field appearance="outline">
                            <mat-label>Moneda de Pago *</mat-label>
                            <mat-select [(ngModel)]="contratoDTO.monedaPago">
                                <mat-option *ngFor="let moneda of monedasPago" [value]="moneda.value">
                                    {{ moneda.label }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>

                        <!-- Monto Alquiler -->
                        <mat-form-field appearance="outline">
                            <mat-label>Monto Alquiler *</mat-label>
                            <input matInput type="number" [(ngModel)]="contratoDTO.alquiler.monto"
                                (ngModelChange)="onMontoAlquilerChange()" placeholder="0.00">
                            <span matPrefix>$&nbsp;</span>
                        </mat-form-field>
                    </div>

                    <div class="form-step-buttons">
                        <button mat-button matStepperPrevious type="button">Volver</button>
                        <button mat-raised-button color="primary" matStepperNext type="button">Siguiente</button>
                    </div>
                </div>
            </mat-step>

            <!-- STEP 3: Configuración de Ajustes y Forma de Pago (UNIFICADO) -->
            <mat-step [completed]="contratoDTO.tipoAjuste && contratoDTO.formaDePago && isPaymentFormValid()">
                <ng-template matStepLabel>Ajustes y Forma de Pago</ng-template>

                <div class="form-step">
                    <!-- SECCIÓN: Ajustes de Precio -->
                    <h4>Configuración de Ajustes</h4>

                    <mat-form-field appearance="outline" style="width: 100%;">
                        <mat-label>Tipo de Ajuste *</mat-label>
                        <mat-select [(ngModel)]="contratoDTO.tipoAjuste" (selectionChange)="onTipoAjusteChange()">
                            <mat-option *ngFor="let ajuste of tiposAjuste" [value]="ajuste.value">
                                {{ ajuste.label }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <div *ngIf="tieneAjuste">
                        <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 16px; margin-bottom: 16px;">
                            <mat-form-field appearance="outline">
                                <mat-label>Tipo de Índice *</mat-label>
                                <mat-select [(ngModel)]="contratoDTO.tipoIndiceAjuste"
                                    (selectionChange)="onTipoIndiceChange()">
                                    <mat-option *ngFor="let indice of tiposIndiceAjuste" [value]="indice.value">
                                        {{ indice.label }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>

                            <mat-form-field appearance="outline">
                                <mat-label>Frecuencia de Ajuste</mat-label>
                                <mat-select [(ngModel)]="contratoDTO.frecuenciaAjuste">
                                    <mat-option *ngFor="let freq of frecuenciasAjuste" [value]="freq.value">
                                        {{ freq.label }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>

                        <div *ngIf="requierePorcentaje">
                            <mat-form-field appearance="outline" style="width: 100%;">
                                <mat-label>Porcentaje de Aumento *</mat-label>
                                <input matInput type="number" [(ngModel)]="contratoDTO.porcentajeAumento"
                                    placeholder="0.00">
                                <span matSuffix>%</span>
                            </mat-form-field>
                        </div>
                    </div>

                    <mat-divider style="margin: 32px 0;"></mat-divider>

                    <!-- SECCIÓN: Forma de Pago -->
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Forma de Pago *</mat-label>
                        <mat-select [(ngModel)]="contratoDTO.formaDePago">
                            <mat-option *ngFor="let forma of formasPago" [value]="forma.value">
                                {{ forma.label }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <!-- Campos condicionales según forma de pago -->
                    <div *ngIf="formaDePagoSeleccionada === 'TransferenciaCBU'" class="row">
                        <div class="col-md-6">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>CBU del Locador *</mat-label>
                                <input matInput [(ngModel)]="contratoDTO.nroCBULocador"
                                    placeholder="0123456789012345678901">
                            </mat-form-field>
                        </div>
                        <div class="col-md-6">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Alias del Locador *</mat-label>
                                <input matInput [(ngModel)]="contratoDTO.aliasLocador" placeholder="PROPIETARIO.MP">
                            </mat-form-field>
                        </div>
                    </div>

                    <div *ngIf="formaDePagoSeleccionada === 'DepositoBancario'" class="row">
                        <div class="col-md-6">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Banco *</mat-label>
                                <input matInput [(ngModel)]="contratoDTO.bancoLocador"
                                    placeholder="Banco de la Nación Argentina">
                            </mat-form-field>
                        </div>
                        <div class="col-md-6">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Número de Cuenta *</mat-label>
                                <input matInput [(ngModel)]="contratoDTO.nroCuentaBancoLocador"
                                    placeholder="1234567890">
                            </mat-form-field>
                        </div>
                    </div>

                    <div *ngIf="formaDePagoSeleccionada === 'EfectivoenInmobiliaria'">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Domicilio de la Inmobiliaria *</mat-label>
                            <textarea matInput [(ngModel)]="contratoDTO.domicilioPagoInmobiliaria" rows="2"
                                placeholder="Av. Corrientes 1234, CABA"></textarea>
                        </mat-form-field>
                    </div>

                    <!-- Depósito de Garantía -->
                    <h4 style="margin-top: 32px; margin-bottom: 16px;">Depósito de Garantía</h4>
                    <div style="display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 16px;">
                        <mat-form-field appearance="outline">
                            <mat-label>Moneda</mat-label>
                            <mat-select [(ngModel)]="contratoDTO.monedaDepositoGarantia">
                                <mat-option value="ARS">Pesos Argentinos</mat-option>
                                <mat-option value="USD">Dólares</mat-option>
                            </mat-select>
                        </mat-form-field>

                        <mat-form-field appearance="outline">
                            <mat-label>Monto</mat-label>
                            <input matInput type="number" [(ngModel)]="contratoDTO.montoDepositoGarantia">
                            <span matPrefix>$&nbsp;</span>
                        </mat-form-field>

                        <mat-form-field appearance="outline">
                            <mat-label>Meses Equivalentes</mat-label>
                            <input matInput type="number" [(ngModel)]="contratoDTO.mesesDepositoGarantia">
                        </mat-form-field>
                    </div>

                    <div class="form-step-buttons">
                        <button mat-button matStepperPrevious type="button">Volver</button>
                        <button mat-raised-button color="primary" matStepperNext type="button">Siguiente</button>
                    </div>
                </div>
            </mat-step>

            <!-- STEP 4: Gastos Contratuales -->
            <mat-step>
                <ng-template matStepLabel>Gastos Contratuales</ng-template>

                <div class="form-step">
                    <h4>Gastos Contratuales</h4>

                    <!-- Checkboxes -->
                    <div style="display: grid; grid-template-columns: 1fr; gap: 16px; margin-bottom: 32px;">
                        <mat-checkbox [(ngModel)]="contratoDTO.expensasOrdinarias">
                            Incluir expensas ordinarias a cargo del locatario
                        </mat-checkbox>
                    </div>

                    <!-- Gastos de Instrumentación con Radio Buttons -->
                    <h4 style="margin-bottom: 24px;">Gastos de Instrumentación</h4>

                    <!-- Responsable de sellos -->
                    <div
                        style="margin-bottom: 24px; padding: 20px; border: 1px solid #ddd; border-radius: 6px; background-color: #f9f9f9;">
                        <div
                            style="font-size: 18px; font-weight: 600; color: #2c3e50; margin-bottom: 14px; line-height: 1.3;">
                            Responsable del Impuesto de Sellos
                        </div>
                        <mat-radio-group [(ngModel)]="contratoDTO.responsableSellos">
                            <div style="display: flex; gap: 24px; margin-top: 8px;">
                                <mat-radio-button value="EL LOCADOR" class="small-radio">
                                    A cargo del Locador
                                </mat-radio-button>
                                <mat-radio-button value="EL LOCATARIO" class="small-radio">
                                    A cargo del Locatario
                                </mat-radio-button>
                            </div>
                        </mat-radio-group>
                    </div>

                    <!-- Certificación de firmas ante Escribano Público -->
                    <div
                        style="margin-bottom: 24px; padding: 20px; border: 1px solid #ddd; border-radius: 6px; background-color: #f9f9f9;">
                        <div
                            style="font-size: 18px; font-weight: 600; color: #2c3e50; margin-bottom: 14px; line-height: 1.3;">
                            Gastos y Honorarios de Certificación de firmas ante Escribano Público
                        </div>
                        <mat-radio-group [(ngModel)]="contratoDTO.gastoCertificacionEscribano">
                            <div style="display: flex; gap: 24px; margin-top: 8px;">
                                <mat-radio-button value="locatario" class="small-radio">
                                    A cargo del Locatario
                                </mat-radio-button>
                                <mat-radio-button value="locador" class="small-radio">
                                    A cargo del Locador
                                </mat-radio-button>
                            </div>
                        </mat-radio-group>
                    </div>

                    <!-- Certificación de firma del Locador -->
                    <div
                        style="margin-bottom: 24px; padding: 20px; border: 1px solid #ddd; border-radius: 6px; background-color: #f9f9f9;">
                        <div
                            style="font-size: 18px; font-weight: 600; color: #2c3e50; margin-bottom: 14px; line-height: 1.3;">
                            Gastos y Honorarios de Certificación de firma del Locador y su cónyuge
                        </div>
                        <mat-radio-group [(ngModel)]="contratoDTO.gastoCertificacionLocador">
                            <div style="display: flex; gap: 24px; margin-top: 8px;">
                                <mat-radio-button value="locatario" class="small-radio">
                                    A cargo del Locatario
                                </mat-radio-button>
                                <mat-radio-button value="locador" class="small-radio">
                                    A cargo del Locador
                                </mat-radio-button>
                            </div>
                        </mat-radio-group>
                    </div>

                    <!-- Consulta de Antecedentes Crediticios -->
                    <div
                        style="margin-bottom: 24px; padding: 20px; border: 1px solid #ddd; border-radius: 6px; background-color: #f9f9f9;">
                        <div
                            style="font-size: 18px; font-weight: 600; color: #2c3e50; margin-bottom: 14px; line-height: 1.3;">
                            Gastos de Gestión de Consulta de Antecedentes Crediticios
                        </div>
                        <mat-radio-group [(ngModel)]="contratoDTO.gastoAntecedentesCrediticios">
                            <div style="display: flex; gap: 24px; margin-top: 8px;">
                                <mat-radio-button value="locatario" class="small-radio">
                                    A cargo del Locatario
                                </mat-radio-button>
                                <mat-radio-button value="locador" class="small-radio">
                                    A cargo del Locador
                                </mat-radio-button>
                            </div>
                        </mat-radio-group>
                    </div>

                    <!-- Informes de Dominio -->
                    <div
                        style="margin-bottom: 24px; padding: 20px; border: 1px solid #ddd; border-radius: 6px; background-color: #f9f9f9;">
                        <div
                            style="font-size: 18px; font-weight: 600; color: #2c3e50; margin-bottom: 14px; line-height: 1.3;">
                            Gastos de Informes de Dominio e Informe de Frecuencia sobre el Inmueble
                        </div>
                        <mat-radio-group [(ngModel)]="contratoDTO.gastoInformesDominio">
                            <div style="display: flex; gap: 24px; margin-top: 8px;">
                                <mat-radio-button value="locatario" class="small-radio">
                                    A cargo del Locatario
                                </mat-radio-button>
                                <mat-radio-button value="locador" class="small-radio">
                                    A cargo del Locador
                                </mat-radio-button>
                            </div>
                        </mat-radio-group>
                    </div>

                    <!-- Honorarios de redacción contractual -->
                    <div
                        style="margin-bottom: 24px; padding: 20px; border: 1px solid #ddd; border-radius: 6px; background-color: #f9f9f9;">
                        <div
                            style="font-size: 18px; font-weight: 600; color: #2c3e50; margin-bottom: 14px; line-height: 1.3;">
                            Honorarios por la redacción Contractual de este Contrato
                        </div>
                        <mat-radio-group [(ngModel)]="contratoDTO.honorariosRedaccion">
                            <div style="display: flex; gap: 24px; margin-top: 8px;">
                                <mat-radio-button value="locatario" class="small-radio">
                                    A cargo del Locatario
                                </mat-radio-button>
                                <mat-radio-button value="locador" class="small-radio">
                                    A cargo del Locador
                                </mat-radio-button>
                            </div>
                        </mat-radio-group>
                    </div>

                    <div class="form-step-buttons">
                        <button mat-button matStepperPrevious type="button">Volver</button>
                        <button mat-raised-button color="primary" matStepperNext type="button">Siguiente</button>
                    </div>
                </div>
            </mat-step>
            <!-- STEP 5: Resumen y Confirmación - REORGANIZADO -->
            <mat-step>
                <ng-template matStepLabel>Resumen</ng-template>

                <div class="form-step">
                    <h4>Resumen del Contrato</h4>

                    <div class="summary-container" *ngIf="warranty">

                        <!-- Sección Propiedad -->
                        <div class="summary-section">
                            <h5>Propiedad</h5>
                            <div class="summary-item">
                                <span class="label">Ubicación:</span>
                                <span class="value">{{ contratoDTO.propiedad?.domicilio }}</span>
                            </div>
                        </div>
                        <!-- Sección Datos Generales -->
                        <div class="summary-section">
                            <h5>Información General</h5>
                            <div class="summary-grid">
                                <div class="summary-item">
                                    <span class="label">Fecha de Firma:</span>
                                    <span class="value">{{ contratoDTO.fechaFirma | date }}</span>
                                </div>
                                <div class="summary-item">
                                    <span class="label">Ciudad:</span>
                                    <span class="value">{{ contratoDTO.ciudadFirma }}</span>
                                </div>
                                <div class="summary-item">
                                    <span class="label">Plazo:</span>
                                    <span class="value">{{ contratoDTO.plazoContrato }} meses</span>
                                </div>
                                <div class="summary-item">
                                    <span class="label">Tipo de Inmueble:</span>
                                    <span class="value">{{ contratoDTO.tipoInmueble | titlecase }}</span>
                                </div>
                            </div>
                        </div>

                        <!-- Sección Datos Monetarios -->
                        <div class="summary-section">
                            <h5>Datos Monetarios</h5>
                            <div class="summary-grid">
                                <div class="summary-item">
                                    <span class="label">Alquiler Mensual:</span>
                                    <span class="value">${{ contratoDTO.alquiler?.monto | number }}</span>
                                </div>
                                <div class="summary-item">
                                    <span class="label">Moneda:</span>
                                    <span class="value">{{ contratoDTO.monedaPago === 'pesos' ? 'Pesos Argentinos' :
                                        'Dólares' }}</span>
                                </div>
                                <div class="summary-item">
                                    <span class="label">Tipo de Ajuste:</span>
                                    <span class="value">{{ contratoDTO.tipoAjuste === 'ninguno' ? 'Sin ajuste' : 'Con
                                        ajuste' }}</span>
                                </div>
                                <div class="summary-item">
                                    <span class="label">Depósito de Garantía:</span>
                                    <span class="value">${{ contratoDTO.montoDepositoGarantia | number }}</span>
                                </div>
                            </div>
                        </div>

                        <!-- Sección Forma de Pago -->
                        <div class="summary-section">
                            <h5>Forma de Pago</h5>
                            <div class="summary-item">
                                <span class="label">Modalidad:</span>
                                <span class="value">{{ getFormaDePagoLabel(contratoDTO.formaDePago) }}</span>
                            </div>
                            <div *ngIf="contratoDTO.formaDePago === 'TransferenciaCBU'" class="payment-details">
                                <div class="summary-item">
                                    <span class="label">CBU:</span>
                                    <span class="value">{{ contratoDTO.nroCBULocador }}</span>
                                </div>
                                <div class="summary-item">
                                    <span class="label">Alias:</span>
                                    <span class="value">{{ contratoDTO.aliasLocador }}</span>
                                </div>
                            </div>
                            <div *ngIf="contratoDTO.formaDePago === 'DepositoBancario'" class="payment-details">
                                <div class="summary-item">
                                    <span class="label">Banco:</span>
                                    <span class="value">{{ contratoDTO.bancoLocador }}</span>
                                </div>
                                <div class="summary-item">
                                    <span class="label">Cuenta:</span>
                                    <span class="value">{{ contratoDTO.nroCuentaBancoLocador }}</span>
                                </div>
                            </div>
                        </div>

                        <!-- Sección Personas -->
                        <div class="summary-section">
                            <h5>Partes del Contrato</h5>
                            <div class="row">
                                <div class="col-md-6">
                                    <h6>Propietarios</h6>
                                    <div class="persons-list">
                                        <div *ngFor="let prop of contratoDTO.propietarios" class="person-item">
                                            <div class="person-name">{{ prop.nombre }}</div>
                                            <div class="person-details">
                                                DNI: {{ prop.documento }} | CUIT: {{ prop.cuit || 'No especificado' }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <h6>Inquilinos</h6>
                                    <div class="persons-list">
                                        <div *ngFor="let inq of contratoDTO.inquilinos" class="person-item">
                                            <div class="person-name">{{ inq.nombre }}</div>
                                            <div class="person-details">
                                                DNI: {{ inq.documento }} | CUIT: {{ inq.cuit || 'No especificado' }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <!-- Botones de Acción -->
                    <div class="action-buttons-section">
                        <!-- Estado: Antes de generar contrato -->
                        <div *ngIf="!contratoGenerado" class="action-buttons">
                            <button mat-raised-button color="accent" type="button" (click)="generatePreview()"
                                [disabled]="!isFormValid()">
                                Vista Previa
                            </button>

                            <button mat-raised-button color="primary" type="button" (click)="confirmContract()"
                                [disabled]="!isFormValid() || generandoContrato">
                                {{ generandoContrato ? 'Generando...' : 'Confirmar Contrato' }}
                            </button>
                        </div>

                        <!-- Estado: Después de generar contrato -->
                        <div *ngIf="contratoGenerado" class="contract-success">
                            <p class="success-text">
                                <mat-icon>check_circle</mat-icon>
                                Contrato generado exitosamente
                            </p>

                            <div class="download-buttons">
                                <button mat-raised-button color="primary" type="button" (click)="downloadPDF()">
                                    Descargar PDF
                                </button>

                                <button mat-raised-button color="accent" type="button" (click)="downloadDOCX()">
                                    Descargar DOCX
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="form-step-buttons">
                        <button mat-button matStepperPrevious type="button" [disabled]="generandoContrato">
                            Volver
                        </button>
                    </div>
                </div>
            </mat-step>
        </mat-horizontal-stepper>
    </div>
</app-nav>